module.exports = __webpack_public_path__ + "static/671454bd.AE-328-fr.png";